import { useState } from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa6';
import { NavLink } from "react-router-dom";

const TopBrandItem = ({ brand, imagePath }) => {
    const [city, setCity] = useState(localStorage.getItem("selectedCity") || "hyderabad");
    const [liked, setLiked] = useState(false);
    return (
        <div
            className="brand-card position-relative text-center me-3 flex-shrink-0 p-3 bg-white rounded shadow-sm"
            style={{ width: '120px', cursor: 'pointer' }}
        >

            {/* Like Button */}
            <button
                className="like-btn position-absolute top-0 end-0 m-1 btn p-0 border-0 bg-transparent"
                onClick={(e) => {
                    e.preventDefault();

                }}
            >

            </button>

            {/* Brand Redirect */}
            <NavLink

                to={`${brand.slug}`}
                className="text-decoration-none text-dark"
            >
                <img
                    src={`${imagePath}${brand.img}`}
                    alt={brand.name}
                    className="img-fluid mb-2"
                    style={{ maxHeight: '60px', objectFit: 'contain' }}
                />

                <div className="fw-bold small">{brand.name}</div>

                {brand.price && (
                    <>
                        <small className="text-muted">Starting From</small>
                        <div className="fw-bold" style={{ fontSize: '13px' }}>
                            {brand.price}
                        </div>
                    </>
                )}
            </NavLink>

        </div>
    );
};

export default TopBrandItem;
